import { useSelector } from 'react-redux'

const getUser = ({ user }) => user
export const useUser = () => {
  return useSelector(getUser)
}
